import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/terms-of-service")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-foreground mb-8">
        Terms of Service
      </h1>

      <div className="prose prose-lg max-w-none dark:prose-invert">
        <p className="text-muted-foreground mb-6">
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            1. Acceptance of Terms
          </h2>
          <p className="text-muted-foreground mb-4">
            By accessing and using EmojiChess ("the Service"), you accept and
            agree to be bound by the terms and provision of this agreement. If
            you do not agree to abide by the above, please do not use this
            service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            2. Description of Service
          </h2>
          <p className="text-muted-foreground mb-4">
            EmojiChess is an online chess platform that uses emoji
            representations for chess pieces, providing an innovative and
            accessible way to play chess. The Service allows users to play chess
            games, track their progress, and interact with other players.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            3. User Accounts
          </h2>
          <p className="text-muted-foreground mb-4">
            To access certain features of the Service, you may be required to
            create an account. You are responsible for:
          </p>
          <ul className="list-disc pl-6 text-muted-foreground mb-4">
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and current information</li>
            <li>
              Notifying us immediately of any unauthorized use of your account
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            4. User Conduct
          </h2>
          <p className="text-muted-foreground mb-4">You agree not to:</p>
          <ul className="list-disc pl-6 text-muted-foreground mb-4">
            <li>Use the Service for any unlawful purposes</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>
              Attempt to gain unauthorized access to any portion of the Service
            </li>
            <li>Harass, abuse, or harm other users</li>
            <li>Use automated scripts or bots to interact with the Service</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            5. Intellectual Property
          </h2>
          <p className="text-muted-foreground mb-4">
            The Service and its original content, features, and functionality
            are and will remain the exclusive property of EmojiChess and its
            licensors. The Service is protected by copyright, trademark, and
            other laws.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            6. Privacy
          </h2>
          <p className="text-muted-foreground mb-4">
            Your privacy is important to us. Please review our Privacy Policy,
            which also governs your use of the Service, to understand our
            practices.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            7. Disclaimers
          </h2>
          <p className="text-muted-foreground mb-4">
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis. We
            make no representations or warranties of any kind, express or
            implied, as to the operation of the Service or the information,
            content, materials, or products included on this Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            8. Limitation of Liability
          </h2>
          <p className="text-muted-foreground mb-4">
            In no event shall EmojiChess, its directors, employees, or agents be
            liable for any indirect, incidental, special, consequential, or
            punitive damages arising out of your use of the Service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            9. Termination
          </h2>
          <p className="text-muted-foreground mb-4">
            We may terminate or suspend your account and bar access to the
            Service immediately, without prior notice or liability, under our
            sole discretion, for any reason whatsoever, including but not
            limited to a breach of the Terms.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            10. Changes to Terms
          </h2>
          <p className="text-muted-foreground mb-4">
            We reserve the right to modify or replace these Terms at any time.
            If a revision is material, we will provide at least 30 days notice
            prior to any new terms taking effect.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            11. Contact Information
          </h2>
          <p className="text-muted-foreground mb-4">
            If you have any questions about these Terms of Service, please
            contact us at:
          </p>
          <p className="text-muted-foreground">
            Email: support@emojichess.com
            <br />
            Address: 382 NE 191st St PMB 92929 Miami, Florida
          </p>
        </section>
      </div>
    </div>
  );
}

